import { ActionIcon, MantineSpacing, StyleProp } from "@mantine/core";
import styles from "./HorizontalPaginationButton.module.css";

type HorizontalPaginationButtonProps = {
  children: React.ReactNode;
  style?: React.CSSProperties;
  onClick: () => void;
  disabled: boolean;
  left?: StyleProp<MantineSpacing>;
  right?: StyleProp<MantineSpacing>;
};

function HorizontalPaginationButton({ children, style, ...props }: HorizontalPaginationButtonProps) {
  return (
    <ActionIcon variant="subtle" radius="xl" size="xl" className={styles.button} {...props} style={style}>
      {children}
    </ActionIcon>
  );
}

export default HorizontalPaginationButton;
